import '@reach/accordion/styles.css';
import '@reach/checkbox/styles.css';
import '@reach/dialog/styles.css';
import '@reach/listbox/styles.css';
import '@reach/tabs/styles.css';
import '../services/analytics';

import React from 'react';
import { useTranslation } from 'react-i18next';
import initI18n from '@quicktools/shared-components/services/i18n';
import { AnalyticsScript, SingleToolsBootstrap } from '@quicktools/shared-components';
import NextHead from '@quicktools/shared-components/components/common/NextHead';

import translations from '../services/i18n/translation.json';
import { appConfig, BASE_URL } from '../configs';

import type { AppProps } from 'next/app';

initI18n(translations);

function MyApp({ Component, pageProps }: AppProps) {
  const { t } = useTranslation();

  return (
    <>
      <AnalyticsScript />
      <NextHead
        title={t('seo.title')}
        description={t('seo.description')}
        imageUrl={appConfig.heroBannerImgUrl}
        canonicalPath={BASE_URL}
      />
      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>
    </>
  );
}

export default MyApp;
